import React from "react";
import { GlobalContext } from "../../../../../utils/globalprovider";
import ToolsBar from "../../../../../components/bases/toolsbar/toolsbar";

import SubtitleRange from "./SubtitleRange/SubtitleRange";
import SubtitleSearchBlock from "./subtitlesearchblocks";

import imgselectallst from "./assets/selectallst.png"
import imgunselectallst from "./assets/unselectallst.png"
import imgexit from "./assets/exit.png"

import "./submenus.css"
import { secondsToTimecodeWithMilliseconds } from "../../utils";

class SelectRange extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.state =
        {
            toolsbar : {
                height: 26,
                items: [
                    {type:"space"},
                    {img: imgselectallst ,type:"button", disable:false,fr:"Sélectionner les sous-titres",en:"Select Subtitles", nochangecolor:false, key:{key:"SELECT", cat:"actions"}},
                    {img: imgunselectallst ,type:"button", disable:false,fr:"Désélectionner les sous-titres",en:"Unselect Subtitles", nochangecolor:false, key:{key:"UNSELECT", cat:"actions"}},
                    {type:"space"},
                    {img: imgexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                    {type:"space"},

                    ],
            },

            min: 1,
            max: this.props.subtitles.length,
        }

        this.onClickToolsBar = this.onClickToolsBar.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);

        this.subtitleSearchBlockRef = React.createRef();
    }

    onClickToolsBar(datas)
    {
        switch (datas.key)
        {
            case "EXIT":
                if (this.props.onaction) this.props.onaction ({source:"submenu", submenu: {key:"EXIT"}});
                break;
            case "SELECT":
                if (this.props.onaction) this.props.onaction ({source:"submenu", submenu: {key:"selectrange"}, values:{min:this.state.min, max:this.state.max, attributes: this.subtitleSearchBlockRef.current.getValues()}});
                break;
            case "UNSELECT":
                if (this.props.onaction) this.props.onaction ({source:"submenu", submenu: {key:"unselectrange"}, values:{min:this.state.min, max:this.state.max, attributes: this.subtitleSearchBlockRef.current.getValues()}});
                break;
        }
    }

    handleOnChange(start, end)
    {
        this.setState ({min:start,max:end});
    }

    getRange ()
    {
        return {min: this.state.min, max: this.state.max};
    }

    render()
    {
        const title = this.context.language=="fr"?"Sélectionner une plage de sous-titres et attributs":"Subtitles range and attributes";
                return (
                    <div className="submenuMain">
                            <div className="submenuTitle">{title}</div>
                            <div className="submenuCurrentDiv">
                                <SubtitleSearchBlock ref={this.subtitleSearchBlockRef} />
                                <SubtitleRange
                                maxSubtitles = {this.props.subtitles.length}
                                onChange = {this.handleOnChange}/>
                                <br/>
                            </div>
                            <div className="submenuBottom">
                            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} />
                            </div>
                    
                    </div>
                )

    }

}

SelectRange.defaultProps = 
{
    subtitles:[]
}

export default SelectRange;



